import React, { useState } from 'react';
import Posts from "../../posts/Posts";
import { BodyContainer, Container } from "../StyledComponents/StyledComponents";
import Button from '../Utility/Button';
import styled from 'styled-components';

// Diferentes estilos de tarjetas para experimentar
const CardStyle1 = styled.div`
    background: ${props => props.theme.colors.gray};
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 2rem;
    box-shadow: 0 4px 20px rgba(0,0,0,0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    
    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 30px rgba(0,0,0,0.15);
    }
    
    .image-container {
        width: 100%;
        height: 280px;
        overflow: hidden;
        
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
        }
    }
    
    &:hover .image-container img {
        transform: scale(1.05);
    }
    
    .content {
        padding: 2rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 150px;
    }
    
    .card-content {
        flex-grow: 1;
        margin-bottom: 1.5rem;
    }
    
    h3 {
        color: ${props => props.theme.body.headers};
        margin-bottom: 1rem;
        font-size: 1.2rem;
        line-height: 1.4;
        font-weight: 600;
        
        .title {
            font-family: ${props => props.theme.typography.headerFont};
            font-weight: 700;
        }
        
        .abstract {
            font-family: ${props => props.theme.typography.font};
            font-weight: 400;
            opacity: 0.8;
            font-size: 0.9em;
        }
    }
`;

const CardStyle2 = styled.div`
    background: white;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 2rem;
    box-shadow: 0 2px 15px rgba(0,0,0,0.08);
    transition: all 0.3s ease;
    border: 1px solid #f0f0f0;
    
    &:hover {
        box-shadow: 0 12px 35px rgba(0,0,0,0.15);
        
        .image-container img {
            transform: scale(1.05);
        }
    }
    
    .image-container {
        width: 100%;
        height: 250px;
        overflow: hidden;
        position: relative;
        
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
        }
        
        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.1) 100%);
        }
    }
    
    .content {
        padding: 2rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 150px;
    }
    
    .card-content {
        flex-grow: 1;
        margin-bottom: 1.5rem;
    }
    
    h3 {
        color: ${props => props.theme.body.headers};
        margin-bottom: 1rem;
        font-size: 1.1rem;
        line-height: 1.4;
        font-weight: 500;
        
        .title {
            font-family: ${props => props.theme.typography.headerFont};
            font-weight: 700;
        }
        
        .abstract {
            font-family: ${props => props.theme.typography.font};
            font-weight: 400;
            opacity: 0.8;
            font-size: 0.9em;
        }
    }
`;

const CardStyle5 = styled.div`
    background: white;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 2rem;
    box-shadow: 0 2px 15px rgba(0,0,0,0.08);
    border: 1px solid #f0f0f0;
    transition: box-shadow 0.3s ease;
    
    &:hover {
        box-shadow: 0 8px 25px rgba(0,0,0,0.12);
        
        .image-container img {
            transform: scale(1.02);
        }
    }
    
    .image-container {
        width: 100%;
        height: 250px;
        overflow: hidden;
        position: relative;
        
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
        }
        
        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.1) 100%);
        }
    }
    
    .content {
        padding: 2rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 150px;
    }
    
    .card-content {
        flex-grow: 1;
        margin-bottom: 1.5rem;
    }
    
    h3 {
        color: ${props => props.theme.body.headers};
        margin-bottom: 1rem;
        font-size: 1.2rem;
        line-height: 1.4;
        font-weight: 600;
        
        .title {
            font-family: ${props => props.theme.typography.headerFont};
            font-weight: 700;
        }
        
        .abstract {
            font-family: ${props => props.theme.typography.font};
            font-weight: 400;
            opacity: 0.8;
            font-size: 0.9em;
        }
    }
`;

const CardStyle3 = styled.div`
    border: 2px solid ${props => props.theme.body.headers};
    border-radius: 0;
    overflow: hidden;
    margin-bottom: 2rem;
    background: transparent;
    transition: all 0.3s ease;
    position: relative;
    
    &:hover {
        box-shadow: 0 8px 25px rgba(0,0,0,0.12);
        
        .image-container img {
            transform: scale(1.05);
        }
    }
    
    .image-container {
        width: 100%;
        height: 220px;
        overflow: hidden;
        transition: filter 0.3s ease;
        
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            filter: grayscale(100%);
            transition: filter 0.3s ease, transform 0.3s ease;
        }
    }
    
    &:hover .image-container img {
        filter: grayscale(0%);
        transform: scale(1.05);
    }
    
    .content {
        padding: 2rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 150px;
    }
    
    .card-content {
        flex-grow: 1;
        margin-bottom: 1.5rem;
    }
    
    h3 {
        color: ${props => props.theme.body.headers};
        margin-bottom: 1rem;
        font-size: 1.1rem;
        line-height: 1.4;
        font-weight: 500;
        
        .title {
            font-family: ${props => props.theme.typography.headerFont};
            font-weight: 700;
        }
        
        .abstract {
            font-family: ${props => props.theme.typography.font};
            font-weight: 400;
            opacity: 0.8;
            font-size: 0.9em;
        }
    }
`;

// Estilo del artículo destacado (horizontal)
const CardStyle4 = styled.div`
    width: 100%;
    display: flex;
    overflow: hidden;
    margin-bottom: 2rem;
    border-radius: 4px;
    box-sizing: border-box;
    background-color: ${props => props.theme.colors.gray};
    transition: all 0.3s ease;
    
    &:hover {
        box-shadow: 0 8px 25px rgba(0,0,0,0.12);
        transform: translateY(-2px);
    }

    .content {
        display: flex;
        width: 50%;
        justify-content: space-between;
        flex-direction: column;
        padding: 3rem;
        min-height: 250px;
        flex: 1;
    }

    .card-content {
        flex-grow: 1;
        margin-bottom: 1.5rem;
    }

    h3 {
        margin: 0 0 0.75rem 0;
        line-height: 1.4;
        word-wrap: break-word;
        overflow-wrap: break-word;
        color: ${props => props.theme.body.headers};
        font-size: 1.3rem;
        font-family: ${props => props.theme.typography.headerFont};
        font-weight: 600;
        
        .title {
            font-family: ${props => props.theme.typography.headerFont};
            font-weight: 700;
        }
        
        .abstract {
            font-family: ${props => props.theme.typography.font};
            font-weight: 400;
            opacity: 0.8;
            font-size: 0.9em;
        }
    }

    .image-container {
        width: 60%;
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 500px;
        background-color: ${props => props.theme.colors.gray};

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            align-self: flex-end;
        }
    }

    @media (max-width: ${props => props.theme.queries.mobile}) {
        flex-direction: column-reverse;
        background-image: none !important;
        border-radius: 0px;
        background-color: transparent;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        padding-bottom: 4rem;
        height: auto;
        
        .content {
            width: 100%;
            padding: 0;
            min-height: auto;
        }

        .image-container {
            background-color: ${props => props.theme.colors.gray};
            width: 100%;
            border-radius: 4px;
            margin-bottom: 2rem;
            height: 200px;
            
            img {
                border-radius: 4px;
            }
        }
    }
`;

const StyleSelector = styled.div`
    display: flex;
    gap: 1rem;
    margin-bottom: 3rem;
    justify-content: center;
    flex-wrap: wrap;
`;

const StyleButton = styled.button`
    padding: 0.75rem 1.5rem;
    border: 2px solid ${props => props.theme.body.headers};
    background: ${props => props.active ? props.theme.body.headers : 'transparent'};
    color: ${props => props.active ? props.theme.body.background : props.theme.body.headers};
    border-radius: 25px;
    cursor: pointer;
    font-family: ${props => props.theme.typography.font};
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover {
        background: ${props => props.theme.body.headers};
        color: ${props => props.theme.body.background};
    }
`;

const CardsContainer = styled.div`
    display: ${props => props.horizontal ? 'flex' : 'grid'};
    flex-direction: ${props => props.horizontal ? 'column' : 'unset'};
    grid-template-columns: ${props => props.horizontal ? 'none' : 'repeat(auto-fit, minmax(400px, 1fr))'};
    gap: 2rem;
    
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        display: flex;
        flex-direction: column;
    }
`;

const PlaygroundCards = () => {
    const [currentStyle, setCurrentStyle] = useState(1);
    
    const renderCard = (post, index) => {
        const CardComponent = currentStyle === 1 ? CardStyle1 : 
                           currentStyle === 2 ? CardStyle2 : 
                           currentStyle === 3 ? CardStyle3 : 
                           currentStyle === 4 ? CardStyle4 : CardStyle5;
        
        // Para el estilo horizontal (CardStyle4), usamos un layout diferente
        if (currentStyle === 4) {
            const [title, abstract] = (post.title + " — " + post.description).split(" — ");
            return (
                <CardComponent key={index}>
                    <div className="content">
                        <div className="card-content">
                            <h3>
                                <span className="title">{title}</span>
                                {abstract && (
                                    <>
                                        <span> — </span>
                                        <span className="abstract">{abstract}</span>
                                    </>
                                )}
                            </h3>
                        </div>
                        <Button
                            right
                            text="Ver Más"
                            route={'/post/' + post.id}
                        />
                    </div>
                    <div className="image-container">
                        <img src={post.image} alt={post.title} />
                    </div>
                </CardComponent>
            );
        }
        
        return (
            <CardComponent key={index}>
                <div className="image-container">
                    <img src={post.image} alt={post.title} />
                </div>
                <div className="content">
                    <div className="card-content">
                        <h3>
                            <span className="title">{post.title}</span>
                            <span> — </span>
                            <span className="abstract">{post.description}</span>
                        </h3>
                    </div>
                    <Button
                        right
                        text="Ver Más"
                        route={'/post/' + post.id}
                    />
                </div>
            </CardComponent>
        );
    };

    return (
        <BodyContainer>
            <Container top={6}>
                <Container leftAlign bottom={4}>
                    <h2>Estilos de Tarjetas</h2>
                    <p>Experimenta con diferentes diseños haciendo clic en los botones:</p>
                </Container>
                
                <StyleSelector>
                    <StyleButton 
                        active={currentStyle === 1}
                        onClick={() => setCurrentStyle(1)}
                    >
                        Tarjetas Elevadas
                    </StyleButton>
                    <StyleButton 
                        active={currentStyle === 2}
                        onClick={() => setCurrentStyle(2)}
                    >
                        Tarjetas Limpias
                    </StyleButton>
                    <StyleButton 
                        active={currentStyle === 3}
                        onClick={() => setCurrentStyle(3)}
                    >
                        Tarjetas Monocromáticas
                    </StyleButton>
                    <StyleButton 
                        active={currentStyle === 4}
                        onClick={() => setCurrentStyle(4)}
                    >
                        Selección del Editor
                    </StyleButton>
                    <StyleButton 
                        active={currentStyle === 5}
                        onClick={() => setCurrentStyle(5)}
                    >
                        Tarjetas Estáticas
                    </StyleButton>
                </StyleSelector>
                
                <CardsContainer horizontal={currentStyle === 4}>
                    {Posts.slice(0, 6).map((post, index) => renderCard(post, index))}
                </CardsContainer>
            </Container>
        </BodyContainer>
    );
};

export default PlaygroundCards;
